import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class AccumulatorIssueType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._description = init.description
    this._request_type = init.request_type
    this._employee_id = init.employee_id
    this._form_attachment = init.form_attachment
    this._id = init.id
    this._updated_at = init.updated_at
  }

  static shape = {
    description: PropTypes.string,
    request_type: PropTypes.string,
    employee_id: PropTypes.number,
    form_attachment: PropTypes.string,
    id: PropTypes.number,
    updated_at: PropTypes.number
  }

  get description() {
    return this._description
  }

  get request_type() {
    return this._request_type
  }

  get employee_id() {
    return this._employee_id
  }

  get form_attachment() {
    return this._form_attachment
  }

  get id() {
    return this._id
  }

  get updated_at() {
    return this._updated_at
  }
}

export default AccumulatorIssueType
